import { render } from "./FundamentosPage.vue?vue&type=template&id=0d98b0aa&scoped=true"
import script from "./FundamentosPage.vue?vue&type=script&lang=js"
export * from "./FundamentosPage.vue?vue&type=script&lang=js"

import "./FundamentosPage.vue?vue&type=style&index=0&id=0d98b0aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d98b0aa"]])

export default __exports__